export const loadRemote = async (url: string) => {
    try {
        // Hack to bypass Webpack 4's parser and force browser-native dynamic import
        // This is necessary because Webpack 4 tries to resolve import() at build time
        // and fails with external URLs or ESM modules it doesn't understand.
        const importNative = new Function('url', 'return import(url)');
        const container = await importNative(url);

        // Initialise the container if needed (Vite remotes might not need this step strictly like Webpack ones)
        // But we definitely need to get the exposed module.
        if (container && container.get) {
            console.log('Loader: Container loaded with get method', container);
            // './web-components' is the key defined in vite.config.ts exposes
            const factory = await container.get('./web-components');
            console.log('Loader: Factory retrieved, executing...');
            // Execute the factory to run the module code (which defines the custom element)
            const Module = factory();
            console.log('Loader: Module executed', Module);
            return Module;
        } else {
            // If container doesn't have get, maybe it just executed side effects (like customElements.define)
            // But the standard interface is get/init. Warning just in case.
            console.warn('Remote container does not expose "get" method. It might have initialized automatically.', container);
            return container;
        }
    } catch (error) {
        console.error(`Failed to load remote script from ${url}`, error);
        throw error;
    }
};
